// reusableComponents/booking/shared/CustomDropdown/index.jsx
import React, { useState, useRef, useEffect } from "react";
import styles from "./styles.module.scss";

const CustomDropdown = ({ 
  options = [], // Default empty array
  value, 
  onChange, 
  placeholder, 
  label,
  disabled = false,
  error = null,
  small = false,
  renderOption,
  renderValue,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  
  // Safety check - ensure options is an array
  const safeOptions = Array.isArray(options) ? options : [];
  const selectedOption = safeOptions.find(opt => opt.value === value);
  
  const handleSelect = (option) => {
    if (!disabled) {
      onChange(option.value);
      setIsOpen(false);
    }
  };
  
  return (
    <div className={`${styles.dropdown} ${disabled ? styles.disabled : ""} ${small ? styles.small : ""}`} ref={dropdownRef}>
      {label && <label className={styles.label}>{label}</label>}
      
      <button
        type="button"
        className={`${styles.dropdownButton} ${isOpen ? styles.open : ""} ${error ? styles.hasError : ""}`}
        onClick={() => !disabled && setIsOpen(!isOpen)}
        disabled={disabled}
      >
        {renderValue ? (
          renderValue(selectedOption)
        ) : (
          <span className={selectedOption ? styles.selectedValue : styles.placeholder}>
            {selectedOption ? selectedOption.label : placeholder || "Select option"}
          </span>
        )}
        <svg 
          className={`${styles.arrow} ${isOpen ? styles.arrowUp : styles.arrowDown}`} 
          width="12" 
          height="12" 
          viewBox="0 0 12 12" 
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
      
      {isOpen && safeOptions.length > 0 && (
        <div className={styles.dropdownMenu}>
          {safeOptions.map((option, index) => (
            <button
              key={index}
              type="button"
              className={`${styles.dropdownItem} ${option.value === value ? styles.selected : ""}`}
              onClick={() => handleSelect(option)}
            >
              {renderOption ? renderOption(option) : option.label}
            </button>
          ))}
        </div>
      )}
      
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};

export default CustomDropdown;